export default __webpack_public_path__ + "static/body-v2-06-back-width-e7ac722a95a0f52ce3b87602da16ed4b.png";